import { render, staticRenderFns } from "./LoginInterface.vue?vue&type=template&id=1ad1888d&scoped=true&"
import script from "./LoginInterface.vue?vue&type=script&lang=ts&"
export * from "./LoginInterface.vue?vue&type=script&lang=ts&"
import style0 from "./LoginInterface.vue?vue&type=style&index=0&id=1ad1888d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad1888d",
  null
  
)

export default component.exports